// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__AHaSr","welcomeContainer":"Navbar_welcomeContainer__k+yhj","logoContainer":"Navbar_logoContainer__2k84d","logo":"Navbar_logo__MK0b0"};